import { useQuery } from 'react-query'
import { initTransaction } from 'services/easyPay'

export default function useSetInitTransaction(
    id: number,
    cashinType: string,
    amount: number
) {

    const { data, isLoading } = useQuery(
        ['init-transaction-131-31-3123-123-', id, cashinType, amount],
        initTransaction
    )
    return { data, isLoading }
}
